(function(){
  function ready(fn){
    if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function(){
    const root = document.getElementById("zq-quiz");
    if(!root) return;

    const ANIMALS = [
      "Perro","Gato","Caballo","Búho","Toro","Zorro","Rinoceronte","Elefante","Jirafa",
      "Jaguar","Venado","Tiburón","Pingüino","Conejo","León","Gallo","Oso"
    ];

    const COPY = {
      "Perro":"Cultura y confianza. Construyes relaciones reales y equipos leales.",
      "Gato":"Independencia sofisticada. Identidad clara y estética impecable.",
      "Caballo":"Movimiento y evolución. Crecimiento constante y energía de avance.",
      "Búho":"Inteligencia estratégica. Decisiones con análisis y visión de largo plazo.",
      "Toro":"Determinación. Enfoque, fuerza y ejecución sin distracciones.",
      "Zorro":"Estrategia creativa. Adaptabilidad y oportunidades donde otros no ven.",
      "Rinoceronte":"Resiliencia. Avanzas fuerte incluso en entornos difíciles.",
      "Elefante":"Confianza y legado. Solidez, memoria y relaciones duraderas.",
      "Jirafa":"Visión amplia. Detectas oportunidades antes que el mercado.",
      "Jaguar":"Liderazgo silencioso. Precisión, presencia y poder estratégico.",
      "Venado":"Elegancia sensible. Conectas desde lo estético y lo emocional.",
      "Tiburón":"Ambición enfocada. Resultados, rapidez y mentalidad competitiva.",
      "Pingüino":"Comunidad. Trabajo en equipo y cultura colaborativa.",
      "Conejo":"Agilidad e innovación. Velocidad, creatividad y reinvención.",
      "León":"Autoridad natural. Liderazgo visible que inspira respeto.",
      "Gallo":"Energía y visibilidad. Comunicación, impulso y presencia.",
      "Oso":"Protección y estabilidad. Cuidado, respaldo y confianza."
    };

    const QUESTIONS = [
      {
        q:"1) ¿Cómo toma decisiones tu empresa?",
        opts:[
          { t:"Rápido y con intuición", pts:{ "Jaguar":2,"Tiburón":2,"Conejo":1,"Gallo":1 } },
          { t:"Analizando datos y escenarios", pts:{ "Búho":2,"Zorro":2,"Elefante":1 } },
          { t:"Con experiencia y criterio", pts:{ "Elefante":2,"Toro":1,"Oso":1,"León":1 } },
          { t:"En equipo, buscando consenso", pts:{ "Pingüino":2,"Perro":2,"Oso":1 } }
        ]
      },
      {
        q:"2) ¿Qué describe mejor su ritmo de crecimiento?",
        opts:[
          { t:"Constante y disciplinado", pts:{ "Toro":2,"Caballo":2,"Elefante":1 } },
          { t:"Ágil y oportunista", pts:{ "Zorro":2,"Conejo":2,"Tiburón":1 } },
          { t:"Visionario y expansivo", pts:{ "Jirafa":2,"León":1,"Jaguar":1 } },
          { t:"Transformador (reinventarse)", pts:{ "Conejo":1,"Zorro":1,"Gallo":1,"Caballo":1 } }
        ]
      },
      {
        q:"3) ¿Cuál valor define más su cultura?",
        opts:[
          { t:"Confianza y cercanía", pts:{ "Perro":2,"Elefante":1,"Oso":1 } },
          { t:"Independencia y criterio", pts:{ "Gato":2,"Búho":1,"Venado":1 } },
          { t:"Protección y bienestar", pts:{ "Oso":2,"Perro":1,"Pingüino":1 } },
          { t:"Competitividad y logro", pts:{ "Tiburón":2,"León":2,"Jaguar":1 } }
        ]
      },
      {
        q:"4) ¿Cómo quieres que el mercado te perciba?",
        opts:[
          { t:"Premium y elegante", pts:{ "Venado":2,"Gato":2,"Jirafa":1 } },
          { t:"Fuerte y dominante", pts:{ "Jaguar":2,"León":2,"Toro":1 } },
          { t:"Humano y cercano", pts:{ "Perro":2,"Pingüino":1,"Oso":1 } },
          { t:"Inteligente y confiable", pts:{ "Búho":2,"Elefante":2,"Zorro":1 } }
        ]
      },
      {
        q:"5) Cuando hay crisis, ¿qué hacen?",
        opts:[
          { t:"Aguantamos y seguimos", pts:{ "Rinoceronte":2,"Toro":1,"Oso":1 } },
          { t:"Replanteamos estrategia", pts:{ "Zorro":2,"Búho":2,"Jirafa":1 } },
          { t:"Movilizamos al equipo", pts:{ "Pingüino":2,"Perro":1,"Gallo":1 } },
          { t:"Atacamos el problema directo", pts:{ "Jaguar":2,"Tiburón":2,"León":1 } }
        ]
      },
      {
        q:"6) ¿Qué describe mejor su estilo comercial?",
        opts:[
          { t:"Relacional (partnership)", pts:{ "Perro":2,"Elefante":1,"Pingüino":1 } },
          { t:"Consultivo (educa al cliente)", pts:{ "Búho":2,"Venado":1,"Jirafa":1 } },
          { t:"Rápido y agresivo", pts:{ "Tiburón":2,"Jaguar":1,"Gallo":1 } },
          { t:"Creativo y flexible", pts:{ "Zorro":2,"Conejo":1,"Gato":1 } }
        ]
      },
      {
        q:"7) ¿Qué te importa más construir en 3 años?",
        opts:[
          { t:"Reputación y legado", pts:{ "Elefante":2,"Oso":1,"Venado":1 } },
          { t:"Liderazgo del mercado", pts:{ "León":2,"Jaguar":2,"Tiburón":1 } },
          { t:"Cultura y equipo fuerte", pts:{ "Pingüino":2,"Perro":2,"Oso":1 } },
          { t:"Innovación constante", pts:{ "Conejo":2,"Zorro":1,"Búho":1 } }
        ]
      }
    ];

    const card = document.getElementById("zq-card");
    const actions = document.getElementById("zq-actions");
    const progress = document.getElementById("zq-progress");

    let idx = 0;
    const score = {};
    ANIMALS.forEach(a => score[a]=0);

    function emoji(a){
      const m = {
        "Perro":"🐕","Gato":"🐱","Caballo":"🐎","Búho":"🦉","Toro":"🐂","Zorro":"🦊","Rinoceronte":"🦏",
        "Elefante":"🐘","Jirafa":"🦒","Jaguar":"🐆","Venado":"🦌","Tiburón":"🦈","Pingüino":"🐧",
        "Conejo":"🐇","León":"🦁","Gallo":"🐓","Oso":"🐻"
      };
      return m[a] || "✨";
    }

    function topAnimal(){
      let best = ANIMALS[0], bestVal = -Infinity;
      ANIMALS.forEach(a => { if(score[a] > bestVal){ best=a; bestVal=score[a]; } });
      return best;
    }

    function render(){
      progress.textContent = `Pregunta ${idx+1} de ${QUESTIONS.length}`;
      const Q = QUESTIONS[idx];

      card.innerHTML = `
        <h3 style="margin:0 0 10px;color:#111;font-size:18px;line-height:1.3;">${Q.q}</h3>
        <div class="zq-grid">
          ${Q.opts.map((o,i)=>`<button type="button" class="zq-btn" data-i="${i}">${o.t}</button>`).join("")}
        </div>
      `;

      actions.innerHTML = idx>0 ? `<button type="button" id="zq-back" class="zq-ghost">Atrás</button>` : ``;

      card.querySelectorAll("button[data-i]").forEach(btn=>{
        btn.addEventListener("click", ()=>{
          const opt = Q.opts[Number(btn.dataset.i)];
          Object.entries(opt.pts).forEach(([a,p])=>{ if(score[a] !== undefined) score[a]+=p; });
          idx++;
          if(idx < QUESTIONS.length) render();
          else showResult();
        });
      });

      const backBtn = document.getElementById("zq-back");
      if(backBtn){
        backBtn.addEventListener("click", ()=>{
          idx = 0; ANIMALS.forEach(a => score[a]=0);
          render();
        });
      }
    }

    function showResult(){
      progress.textContent = `Resultado listo`;
      const animal = topAnimal();

      const msg = encodeURIComponent(
        `Hola Zutopía, hice el test del Animal Corporativo y mi resultado fue: ${animal}. ` +
        `¿Me puedes mostrar opciones (escultura / rompecabezas / magnético) y una cotización?`
      );
      const wa = `https://wa.me/573122860601?text=${msg}`;

      card.innerHTML = `
        <div style="text-align:center;">
          <div style="font-size:42px;line-height:1;">${emoji(animal)}</div>
          <h3 style="margin:8px 0 4px;color:#111;">Tu empresa es: <span style="text-transform:uppercase;">${animal}</span></h3>
          <p style="margin:0;opacity:.9;color:#111;">${COPY[animal] || ""}</p>
          <div style="margin-top:14px;padding:12px;border-radius:12px;background:#f7f7f7;color:#111;">
            <strong>Tip Zutopía:</strong> este resultado puede convertirse en una pieza de arte para oficina o en regalos corporativos para tu equipo. 
            También desarrollamos diseños totalmente personalizados basados en la mascota de tu empresa, su identidad o el mensaje que quieran comunicar.
          </div>
        </div>
      `;

      actions.innerHTML = `
        <a href="${wa}" target="_blank" class="zq-linkbtn">Cotizar por WhatsApp</a>
        <button type="button" id="zq-restart" class="zq-ghost">Repetir test</button>
      `;

      document.getElementById("zq-restart").addEventListener("click", ()=>{
        idx = 0; ANIMALS.forEach(a => score[a]=0);
        render();
      });
    }

    render();
  });
})();
